// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout___1XhSp","sider":"sider___27T6b","header":"header___2_57M","content":"content___2QN8t"};